import React from "react";

// Asset Imports for fallback/static icons if needed
import mobileIcon from "../../images/mobile-portrait.svg";
import timeIcon from "../../images/time-filled.svg";
import deliveryIcon from "../../images/delivery.svg";
import starIcon from "../../images/star-shine.svg";
import centerImage from "../../images/why_choose_us.png";

const WhyChooseUs = ({ data }) => {
  // Destructure dynamic data from props
  const { title: bigTitle, cards = [] } = data || {};

  // Split cards: first two on the left, the rest on the right
  const leftCards = cards.slice(0, 2);
  const rightCards = cards.slice(2);

  // Helper to map icons if the API returns specific keys or use the API URL directly
  const getIcon = (index, apiIcon) => {
    if (apiIcon) return apiIcon;
    // Fallback mapping based on index if API icon is missing
    const fallbacks = [mobileIcon, timeIcon, deliveryIcon, starIcon];
    return fallbacks[index] || starIcon;
  };

  return (
    <section
      id="choose_us"
      className="w-full  bg-white py-16 px-5 md:px-14 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-20 flex flex-col items-center">
          <h2 className="text-3xl md:text-5xl font-bold text-[#15363A] mb-6">
            {/* Split title if it contains "Why" to keep the gold styling */}
            Why <span className="text-[#998147]">Choose Us</span>
          </h2>
          <p className="text-[#4A4A4A] text-sm md:text-[1.1rem] leading-relaxed max-w-[55rem] font-medium">
            There are plenty of distribution businesses out there, but not all
            offer the quality and convenience you get when you partner with
            Gouri Distribution. When you purchase from our wholesale business,
            you get:
          </p>
        </div>

        {/* 3-Column Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-4 items-center relative">
          {/* Left Column (Right-Aligned Text) */}
          <div className="flex flex-col gap-12 md:gap-24 lg:py-10 order-2 lg:order-1 h-full justify-center">
            {leftCards.map((card, index) => (
              <div
                key={index}
                className="flex flex-col items-center lg:items-end text-center lg:text-right"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 bg-[#f8f6f1] flex justify-center items-center rounded-lg mb-4">
                  <img
                    src={getIcon(index, card.icon)}
                    alt={card.title}
                    className="w-6 h-6 md:w-7 md:h-7 object-contain"
                  />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-[#998147] mb-2">
                  {card.title}
                </h3>
                <p className="text-[#4A4A4A] text-sm md:text-base leading-relaxed lg:pl-10">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>

          {/* Center Column (Hero Image) */}
          <div className="flex justify-center relative order-1 mx-10 lg:order-2">
            <img
              src={centerImage}
              alt="Gouri Distribution Representative"
              className="w-full max-w-[20rem] md:max-w-[28rem] lg:max-w-full object-contain scale-105"
            />
          </div>

          {/* Right Column (Left-Aligned Text) */}
          <div className="flex flex-col gap-12 md:gap-24 lg:py-10 order-3 h-full justify-center">
            {rightCards.map((card, index) => (
              <div
                key={index}
                className="flex flex-col items-center lg:items-start text-center lg:text-left"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 bg-[#f8f6f1] flex justify-center items-center rounded-lg mb-4">
                  {/* Using index + 2 to continue the fallback mapping sequence */}
                  <img
                    src={getIcon(index + 2, card.icon)}
                    alt={card.title}
                    className="w-6 h-6 md:w-7 md:h-7 object-contain"
                  />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-[#998147] mb-2">
                  {card.title}
                </h3>
                <p className="text-[#4A4A4A] text-sm md:text-base leading-relaxed lg:pr-10">
                  {card.desc}
                </p>
              </div>
            ))}

            {rightCards.length < 2 && (
              <div className="hidden lg:block h-[12rem]"></div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
